import {MenuItem as MuiMenuItem, MenuItemProps} from '@mui/material'

export const MenuItem = (props: MenuItemProps) => <MuiMenuItem {...props} />